import { NgClass, CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatListItem } from '@angular/material/list';

@Component({
    selector: 'app-record-details',
    templateUrl: './record-details.component.html',
    imports: [CommonModule, NgClass, MatDividerModule, MatListItem, ReactiveFormsModule, FormsModule],
    styleUrls: ['./record-details.component.scss']
})
export class RecordDetailsComponent implements OnInit {

  @Input('ExceptionCodeDetailsCols') ExceptionCodeDetailsCols!: any[];
  @Input('rowDataforDialog') finraExceptionRow: any;
  constructor() { }

  ngOnInit() {
  }

}
